import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-4",
  title,
  items,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.WhyUs)} data-bs-theme={theme}>
      <Container fluid="md">
        <EditableText path="title" tag="h2" className="mb-3">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <Row className="py-4">
          {items.map(({ icon, title, description }, idx) => (
            <Col key={idx} xs={12} md={4}>
              <div className={cn(classes.card, "text-center text-md-start")}>
                <div className="hexagon-alt bg-blue mx-auto mx-md-0 mb-3">
                  <EditableImage path={`item_${idx}_image`} src={icon} alt="" />
                </div>
                <EditableText path={`item_${idx}_title`} tag="h5" className="mb-3">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </EditableText>
                <EditableHtml path={`item_${idx}_description`}>
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </EditableHtml>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
